import { X, Lock } from 'lucide-react'
import { Button } from 'antd'
import type { StakeholderTemplate } from '@bandos/shared'
import { DismissibleTooltip } from '../../../../common/DismissibleTooltip'
import { PortraitDisplay } from './PortraitDisplay'
import {
  TeamSlot as StyledTeamSlot,
  SlotEmptyText,
  SlotName,
  LockedSlotContent,
  LockedSlotText,
} from '../styles/CharacterSelectionModalStyles'

interface TeamSlotProps {
  index: number
  template: StakeholderTemplate | null
  isLocked: boolean
  isOperating: boolean
  isGenerating: boolean
  brokenPortraits: Set<string>
  markPortraitBroken: (id: string) => void
  onSelect: (template: StakeholderTemplate) => void
  onRemove: (index: number) => void
  onShowUpgrade: () => void
}

export function TeamSlotItem({
  index,
  template,
  isLocked,
  isOperating,
  isGenerating,
  brokenPortraits,
  markPortraitBroken,
  onSelect,
  onRemove,
  onShowUpgrade,
}: TeamSlotProps) {
  const isEmpty = !template

  return (
    <StyledTeamSlot
      $isEmpty={isEmpty || isLocked}
      onClick={() => {
        if (isLocked) {
          onShowUpgrade()
        } else if (template) {
          onSelect(template)
        }
      }}
      style={{ cursor: isLocked || template ? 'pointer' : 'default' }}
    >
      {isLocked ? (
        <LockedSlotContent onClick={onShowUpgrade}>
          <Lock size={16} />
          <LockedSlotText>Pro</LockedSlotText>
        </LockedSlotContent>
      ) : isEmpty ? (
        <SlotEmptyText>Empty</SlotEmptyText>
      ) : (
        <>
          <PortraitDisplay
            template={template}
            size="slot"
            brokenPortraits={brokenPortraits}
            markPortraitBroken={markPortraitBroken}
            isGenerating={isGenerating}
          />
          <SlotName>{template.name}</SlotName>
          <DismissibleTooltip title="Remove from team">
            <Button
              type="text"
              shape="circle"
              size="small"
              danger
              icon={<X size={12} />}
              disabled={isOperating}
              onClick={(e) => {
                e.stopPropagation()
                if (!isOperating) void onRemove(index)
              }}
              style={{
                position: 'absolute',
                top: 4,
                right: 4,
                width: 20,
                height: 20,
                minWidth: 20,
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
          </DismissibleTooltip>
        </>
      )}
    </StyledTeamSlot>
  )
}
